var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "k-category" }, [
    _c(
      "div",
      { class: "icon -" + _vm.category.color },
      [
        _c("k-icon", {
          attrs: {
            icon: _vm.category.icon,
            iconColor: _vm.iconColor,
            viewBox: "0 0 24 24",
            width: 32,
            height: 32
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _vm._v("\n    " + _vm._s(_vm.category.name) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01af8368", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01af8368","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/kaledo-components/src/components/KCategory.vue
// module id = 2047
// module chunks = 1609